var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExhibitionModuleGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon beurs black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-beurs-black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.707612537
  }, /*#__PURE__*/React.createElement("g", {
    id: "baseline-explore-24px",
    transform: "translate(8.000000, 8.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,15.6888441 C16.4956317,15.6888441 15.6888441,16.4956317 15.6888441,17.5 C15.6888441,18.5043683 16.4956317,19.3111559 17.5,19.3111559 C18.5043683,19.3111559 19.3111559,18.5043683 19.3111559,17.5 C19.3111559,16.4956317 18.5043683,15.6888441 17.5,15.6888441 Z M17.5,1.03494624 C8.41129032,1.03494624 1.03494624,8.41129032 1.03494624,17.5 C1.03494624,26.5887097 8.41129032,33.9650538 17.5,33.9650538 C26.5887097,33.9650538 33.9650538,26.5887097 33.9650538,17.5 C33.9650538,8.41129032 26.5887097,1.03494624 17.5,1.03494624 Z M21.1058468,21.1058468 L7.62096774,27.3790323 L13.8941532,13.8941532 L27.3790323,7.62096774 L21.1058468,21.1058468 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExhibitionModuleGrey);
export default __webpack_public_path__ + "static/media/exhibition-module-grey.58ba2a69fe9401abbdbf12a95838e138.svg";
export { ForwardRef as ReactComponent };